<app-base-overlay [title]="data == null? 'Create new user': 'Update user'">

  <div body>

    <form [formGroup]="createOrUpdateForm" class="flex flex-col gap-4">

      <app-text-input
        formControlName="firstName"
        label="First Name"
        placeholder="Ex: John"
        class="w-full"
        [fullWidth]="true">
      </app-text-input>

      <app-text-input
        formControlName="lastName"
        label="Last Name"
        placeholder="Ex: Bravo"
        class="w-full"
        [fullWidth]="true">
      </app-text-input>

      <app-text-input
        formControlName="email"
        label="Email"
        placeholder="Ex: john.Bravo@gmail.com"
        class="w-full"
        [fullWidth]="true">
      </app-text-input>

      <app-text-input
        formControlName="phoneNumber"
        label="Phone Number"
        placeholder="Ex: +1 123-456-78XX"
        class="w-full"
        [fullWidth]="true">
      </app-text-input>

      <app-base-input
        title="Company"
        class="w-full"
        [fullWidth]="true">

        <div input class="flex flex-col gap-3">

          <div class="flex flex-wrap gap-2">

            @for (company of companyListState.response()?.data; track company.id) {

              @if (isSelected(company)) {

                <div class="flex items-center gap-2 px-3 py-1 bg-primary-100 text-primary-700 rounded-full text-body1">

                  <p>{{ company.companyName }}</p>

                  <button
                    type="button"
                    (click)="removeCompany(company)">

                    <app-svg-icon
                      [src]="'assets/icons/close.svg'">
                    </app-svg-icon>

                  </button>

                </div>

              }

            }

          </div>

          <div class="border rounded-xl overflow-hidden">

            <div class="sticky top-0 bg-white z-10 p-3 border-b space-y-3">

              <div class="relative">

                <input
                  type="text"
                  placeholder="Search companies..."
                  class="w-full border rounded-lg px-3 py-2 outline-none"
                  (input)="onSearchCompany($event)">

              </div>

              <div class="flex items-center justify-between px-1 py-1">

                <div class="flex items-center gap-2 cursor-pointer"  (click)="onSelectAllCompanies(!isAllSelected)">

                  <app-checkbox
                    [(ngModel)]="isAllSelected"
                    [ngModelOptions]="{ standalone: true }"
                    (valueChanged)="onSelectAllCompanies($event)">
                  </app-checkbox>

                  <label class="font-bold cursor-pointer">
                    Select All Companies
                  </label>

                </div>

                <span class="text-body2 text-neutral-500">
    {{ filteredCompanyList.length }} companies
  </span>

              </div>

            </div>

            <div class="max-h-72 overflow-y-auto">

              @for (company of filteredCompanyList; track company.id) {

                <div
                  class="px-3 py-3 border-b last:border-b-0 hover:bg-neutral-50 transition-all duration-200 rounded-md">

                  <app-checkbox
                    [title]="company.companyName"
                    [(ngModel)]="company.isChecked"
                    [ngModelOptions]="{standalone: true}"
                    (valueChanged)="onCompanySelected(company, $event)">
                  </app-checkbox>

                </div>

              }

            </div>

          </div>

        </div>

      </app-base-input>

    </form>

  </div>

  <div actions class="py-2">

    <app-button
      [fullWidth]="true"
      type="submit"
      [loading]="adminCreateUserState.loading() || adminUpdateUserState.loading()"
      (click)="onSubmitClicked()">

      {{ data == null ? 'Create new user' : 'Update user' }}

    </app-button>

  </div>

</app-base-overlay>
